import { DefaultValue, selector, selectorFamily } from 'recoil';
import { bankAccountsAtom, communicationChannelsAtom, householdAtom, partyAtom, partyPepSanctionStatusAtom, relationsAtom, } from '../atoms';
/**
 * Only use this selector if you want to apply all atoms at once.
 *
 * For example to handle the response of putHouseholdFlow.
 */
export const partyExtendedSelector = selector({
    key: 'derived/partyExtended',
    get: () => {
        throw new Error('Only use the setter! To get party information, use the atoms you need individually.');
    },
    set: ({ set }, value) => {
        if (value instanceof DefaultValue)
            throw new Error('reset not supported!');
        const { householdInformation, relations, ...party } = value;
        const bankAccounts = party.extendedPartyData?.bankAccounts ?? [];
        const channels = party.extendedPartyData?.communicationChannels ?? [];
        set(partyAtom, party);
        set(bankAccountsAtom, { bankAccounts });
        set(communicationChannelsAtom, { channels });
        set(partyPepSanctionStatusAtom, {
            pepStatus: party.extendedPartyData?.pepStatus,
            sanctionStatus: party.extendedPartyData?.sanctionStatus,
        });
        set(householdAtom, householdInformation);
        set(relationsAtom, relations);
    },
});
export const partyExternalBusinessIdsSelector = selector({
    key: 'party/externalBusinessIds',
    get: ({ get }) => get(partyAtom).externalBusinessIds,
});
export const partyExternalBusinessIdValueBySystemSelectorFamily = selectorFamily({
    key: 'party/externalBusinessIds/bySystem',
    get: ({ system }) => ({ get }) => {
        const businessIds = get(partyExternalBusinessIdsSelector);
        return businessIds?.find((businessId) => businessId.externalSystem === system)?.externalKeyValue;
    },
});
// TODO: not sure if we will actually need/use those?
export const partySubTypeSelector = selector({
    key: 'party/subType',
    get: ({ get }) => {
        const party = get(partyAtom);
        return party.partySubType || null;
    },
});
export const partySalutationSelector = selector({
    key: 'party/salutation',
    get: ({ get }) => {
        const party = get(partyAtom);
        return party.salutation || null;
    },
});
